import { render } from "./subject-access-request.vue?vue&type=template&id=c556d706"
import script from "./subject-access-request.vue?vue&type=script&lang=js"
export * from "./subject-access-request.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__